"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketListener = void 0;
const models_1 = require("../models");
const utils_1 = require("../utils");
const DomainEvents_1 = require("../utils/DomainEvents");
const MarkAsReadTracker_1 = __importDefault(require("../chat/MarkAsReadTracker"));
const Observable_1 = require("./Observable");
class SocketListener {
    constructor(userDirectory, organization) {
        this.userDirectory = userDirectory;
        this.organization = organization;
    }
    onReceiveMessage(data) {
        const orgId = this.organization.organizationId;
        const groupStatus = data.chatLog.status;
        const groupType = groupStatus === models_1.GROUP_STATUS.HIDDEN
            ? models_1.GROUP_TYPE.HIDDEN
            : data.chatLog.groupType;
        const { chatType } = data.chatLog;
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getUpdateChatEventKey)(orgId, chatType, groupType), data);
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.RECEIVE_MESSAGE, data.chatLog.from), data.message);
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.RECEIVE_MESSAGE, orgId), { message: data.message, chatLog: data.chatLog });
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.MARK_AS_DELIVERED, orgId), data.message);
    }
    onSocketResponseError(_data) {
        const orgId = this.organization.organizationId;
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.RESPONSE_ERROR, orgId), _data.message || utils_1.ErrorMessages.socketResponseError);
    }
    onSlowMessageSend(data) {
        const orgId = this.organization.organizationId;
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.SLOW_MESSAGE_SEND, orgId), data);
    }
    onReceiveAlert(data) {
        return __awaiter(this, void 0, void 0, function* () {
            let orgId = "";
            switch (data.chatType) {
                case models_1.CHAT_TYPE.GROUP:
                    orgId = data.groupInfo.organizationId;
                    break;
                case models_1.CHAT_TYPE.PRIVATE:
                    orgId = data.info.organizationId;
                    break;
            }
            Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.NEW_ALERT, orgId), data);
            if (data.type === models_1.ALERT_TYPE.ACKNOWLEDGE) {
                Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.NEW_ACKNOWLEDGE_ALERT, orgId), data);
            }
        });
    }
    onReceiveReferralAlert(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (data.type === models_1.ALERT_TYPE.REFERRAL) {
                const orgId = data.groupInfo.organizationId;
                Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.NEW_ALERT, orgId), data);
            }
        });
    }
    onAlertRemove(data) {
        const orgId = this.organization.organizationId;
        const alertRemoveData = {
            alertType: models_1.ALERT_TYPE[data.type],
            chatId: data.from,
            numberOfAlertsRemoved: data.numberOfAlertsRemoved,
        };
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.ALERT_REMOVE, orgId), alertRemoveData);
    }
    onV2AlertRemove(data) {
        const orgId = this.organization.organizationId;
        const alertRemoveData = {
            alertType: models_1.ALERT_TYPE[data.type],
            alertId: data._id,
        };
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.ALERT_REMOVE_ACKNOWLEDGEMENT, orgId), alertRemoveData);
    }
    onMessageUpdated(orgId, data) {
        const chatId = (0, utils_1.getChatIdFromMessage)(data.chatType, data.to, data.user, this.organization.userProfile.id);
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.UPDATE_MESSAGE, chatId), data);
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.ALERT_UPDATE, orgId), data);
    }
    onMessageDeleted(data) {
        data.deletedMessages.forEach((message) => {
            Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.DELETE_MESSAGE, data.chatId), message);
        });
    }
    onNoPendingAcknowledgement(data) {
        const orgId = this.organization.organizationId;
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.NO_PENDING_ACKNOWLEDGEMENT, orgId), data);
    }
    onUpdateGroup(data) {
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.UPDATE_GROUP, data._id), data);
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.UPDATE_CHAT_LIST_ITEM, data.info.organizationId), data);
    }
    onChatLogUpdate(data) {
        MarkAsReadTracker_1.default.getInstance().received(data.lastMessage.to, data.lastMessageRead);
        const orgId = this.organization.organizationId;
        const groupType = data.status === models_1.GROUP_STATUS.HIDDEN ? models_1.GROUP_TYPE.HIDDEN : data.groupType;
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getChatLogUpdateKey)(orgId, data.chatType, groupType), data);
    }
    onNewChat(data) {
        const orgId = this.organization.organizationId;
        const { groupType } = data;
        const { chatType } = data;
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getNewChatEventKey)(orgId, chatType, groupType), data);
    }
    onChatDelete(data) {
        const orgId = this.organization.organizationId;
        const chatType = data.chatType;
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getDeleteChatEventKey)(orgId, chatType), data);
        // Notify to delete all alerts related to this chat
        const alertDeleteEventKey = (0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.ALERT_DELETE, orgId);
        Observable_1.Observable.getInstance().notify(alertDeleteEventKey, data);
    }
    onHideChat(data) {
        const orgId = this.organization.organizationId;
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.HIDE_CHAT, orgId), data);
    }
    onUnHideChat(data) {
        const orgId = this.organization.organizationId;
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.UNHIDE_CHAT, orgId), data);
    }
    onMessageDelivered(data) {
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.MESSAGE_DELIVERED, data._id), data);
    }
    onMessageRead(data) {
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.MESSAGE_READ, data._id), data);
    }
    onUserUpdate(data) {
        if (!data.organizationId) {
            throw new Error("organizationId is required for user-update event");
        }
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.USER_UPDATE, data.organizationId), data);
    }
}
exports.SocketListener = SocketListener;
